import { HelmetDexteel } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { TablePaintCutTypes } from "./components/TablePaintCutTypes";
import { CatalogPaintCutType } from "@/shared/models/CatalogPaintCutType";
import { getCatalogPaintCutTypes } from "@/shared/repositories/CatalogPaintCutTypeRepository";

type useCatalogPaintCutTypesProps = {
	onError?: (error: Error) => void;
};

export const useCatalogPaintCutTypes = ({
	onError,
}: useCatalogPaintCutTypesProps) => {
	return useQuery<CatalogPaintCutType[], Error>({
		queryKey: ["catalogPaintCutTypes"],
		queryFn: () => getCatalogPaintCutTypes(),
		onError: onError,
	});
};

export const CatalogPaintCutTypesPage = () => {
	return (
		<>
			<HelmetDexteel title="Paint Cut Types - Configurations" />
			<TablePaintCutTypes />
		</>
	);
};
